import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { iosColors } from "mobile/components/IosParity";

/**
 * Mobile in-page top bar (use instead of a global header).
 * Pattern: back button -> title/subtitle -> optional right-side node.
 */
export default function MobileTopBar({ title, subtitle, onBack, right }) {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate("/m/dashboard"));
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 12,
        pt: "env(safe-area-inset-top)",
        pb: 0.85,
        px: 0,
        backgroundColor: "rgba(247,248,250,0.94)",
        backdropFilter: "blur(14px)",
        borderBottom: `1px solid ${iosColors.line}`,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.85}>
        <Stack direction="row" alignItems="center" spacing={0.6} sx={{ minWidth: 0, flex: 1 }}>
          <IconButton
            aria-label="Back"
            onClick={handleBack}
            size="small"
            sx={{
              width: 42,
              height: 42,
              bgcolor: "#fff",
              border: `1px solid ${iosColors.line}`,
              boxShadow: "none",
            }}
          >
            <ArrowBackIosNewRoundedIcon sx={{ fontSize: 19 }} />
          </IconButton>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ color: iosColors.ink, fontSize: 17.5, fontWeight: 850, lineHeight: 1.08 }} noWrap>
              {title}
            </Typography>
            {subtitle ? (
              <Typography sx={{ color: iosColors.muted, fontSize: 12.25, fontWeight: 700 }} noWrap>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Stack>
        {right ? <Box sx={{ flex: "0 1 auto", maxWidth: "54%", overflow: "hidden" }}>{right}</Box> : null}
      </Stack>
    </Box>
  );
}

MobileTopBar.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onBack: PropTypes.func,
  right: PropTypes.node,
};
MobileTopBar.defaultProps = {
  subtitle: "",
  onBack: null,
  right: null,
};
